import { getDocHeight } from '../utils/layout/measureDocHeight.js';
import { clamp01 } from '../utils/math.js';
import { getResponsiveMode } from '../utils/responsive-mode.js';
import { debounceRAF } from '../utils/timing.js';

export function initFooterScroll() {

    const footer = document.querySelector('footer');

    const startVh = 200; // équivalent à footerRect.top < vh * 1.5
    const rangeVh = 200; // distance de scroll pour faire l'animation
    const riseVh = 100;  // hauteur max de montée

    const update = () => {

        // Desktop only
        if (getResponsiveMode(footer) !== "desktop") {

            footer.style.transform = "translateY(0px)";

            return;

        }

        const rect = footer.getBoundingClientRect();
        const vh = window.innerHeight;

        const triggerPx = vh * (startVh / 100);

        // Avant le trigger → rien
        if (rect.top >= triggerPx) {
            footer.style.transform = "translateY(0px)";
            return;
        }

        // Progression 0 → 1 sur rangeVh
        const rangePx = vh * (rangeVh / 100);
        const rawProgress = (triggerPx - rect.top) / rangePx;
        const progress = clamp01(rawProgress);

        // Translation finale
        const translateY = -progress * (vh * (riseVh / 100));

        footer.style.willChange = "transform";
        footer.style.transform = `translateY(${translateY}px)`;

        const docHeight = getDocHeight();

        document.body.style.setProperty('--height', `${docHeight + translateY}px`);

    };

    const onScroll = debounceRAF(update);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();

}